<style lang="stylus" scoped>
@import "./cardMap.stylus";
.listFather
  position relative
  .ul
    position absolute
    bottom 0
    left 0
    border 1px solid #ced3de
    z-index 20
li
  list-style none
  height: 36px;
  line-height: 36px;
  padding-left:15px;
  cursor: pointer;
  &:hover
    background:#f2f2f2

</style>
<template>
  <div class="home-main">
    <div class="map-search radius-5 b1 p-2">
      <el-row style='line-height: 76px;font-size: 18px;color: #336db0;'><CardHeader/></el-row>
      <el-form :inline="true" :model="option" class="demo-form-inline" style='margin-left:13px;margin-top:25px;'>
        <el-form-item label="网点编码">
          <el-input v-model.trim.number="option.siteCode" placeholder="网点编码"></el-input>
        </el-form-item>
        <el-form-item label="网点名称">
          <el-input v-model.trim="option.siteName" placeholder="网点名称" style='width:220px;'></el-input>
            <div class="ul" v-if='searchBlock' style='border:1px solid #ced3de;position:fixed;z-index:10;width:220px;background:#fff;border-top-color:transparent;'>
              <li v-for='(item, index) in list' :key='index' @click='editSearch(item)'>{{item.siteName}}</li>
            </div>
        </el-form-item>
        <el-form-item label="日期选择">
          <el-date-picker 
          :clearable="false"
          v-model="option.timeSection"  value-format="timestamp" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="goBack">返回上级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <TotalCard :totalCount = 'totalCount'/>
    <Card v-if='item.cityCode' v-for="(item,index) in cityItem" :key="index" :item='item'/>
    <SiteCard v-else v-for="(item,index) in cityItem" :key='index'/>
  </div>
</template>

<script>
  import CardHeader from './components/cardHeader.vue'
  import Card from './components/card'
  import TotalCard from './components/totalCard.vue'
  import SiteCard from './components/siteCard.vue'

  import http from '@/api/cardData'
  import Cookies from "js-cookie"
  export default {
    name: "home",
    components: {
      CardHeader,
      Card,
      TotalCard,
      SiteCard
    },
    data() {
      return {
        option:{
          timeSection:[new Date(new Date()*1-30*24*3600*1000)*1,new Date()*1],
          siteCode:null,
          siteName:null,
          siteCode1:null,
        },
        list:[],//模糊搜索的数据
        searchBlock:false,
        totalCount:[],//查询的结果集
        cityItem:[],
      };
    },
    created(){
      this.option.timeSection = JSON.parse(this.$route.query.timeSection)?JSON.parse(this.$route.query.timeSection):this.option.timeSection;
      this.option.siteCode = this.$route.query.siteCode?this.$route.query.siteCode:this.option.siteCode;
      this.option.siteName = this.$route.query.siteName?this.$route.query.siteName:this.option.siteName;
      this.onSubmit();
    },
    watch:{
      'option.siteName':function(value,oldValue){
        // let that = this;
        // if(value.length>=2){
        //   that.searchBlock = true;
        //   let _option = {
        //     siteName:value,
        //     phone:Cookies.get('user')
        //   };
        //   //searchSiteDate
        //   http[that.allTab].searchSiteDate(_option).then(e=>{
        //     that.list = e.data.clist;
        //   })
        // }else{
        //   that.searchBlock = false;
        // }
        let that = this
        that.searchBlock = false
        if(value.length>=1){
          let _option = {
            siteName: value,
            phone: Cookies.get('user')
          }
          http[that.allTab].searchSiteDate(_option).then(e => {
            that.list = e.data.clist||[]
            if(that.list.length>1){
              that.searchBlock = true
            }
          })
        }else{
          that.list = [];
        }
      },
      '$store.state.app.tab': function ( value, oldValue ) {
        this.onSubmit()
      },
    },
    computed: {
      'allTab':function(){
        return this.$store.state.app.tab
      },
      'titleArr':function(){
        return this.$store.state.app.titleArr
      },
    },
    methods: {
      goBack(){
        this.$router.replace({
          name:'cardSite'
        })
      },
      initNum(num) {
        num = num + '';
        if (num.indexOf('.') == -1) {
          return num
        }
        return num.split('.')[0]
      },
      onSubmit(){
        let that = this;
        let _option = {
          timeSection:that.option.timeSection,
        }
        if(this.option.siteCode&&(this.option.siteCode+'').length != 8){
          this.$notify.error({
              title: '错误',
              message: '请输入正确的网点编码'
            });
          return
        }
        if ( this.option.siteCode&&this.option.siteCode1 ) {
          if(this.option.siteCode != this.option.siteCode1){
            this.$notify.error({
              title: '错误',
              message: '网点名称与网点编码不一致，请重新输入'
            });
            return
          }
        }
        if ( this.option.siteCode||this.option.siteCode1 ) {
          _option.siteCode  = this.option.siteCode||this.option.siteCode1;
          //vagueSiteDate
          http[that.allTab].vagueSiteDate({
            timeSection:this.option.timeSection,
            siteCode:this.option.siteCode,
            phone:Cookies.get('user')
          }).then(e=>{
            let data = e.data
            that.totalCount = data.totalCount
            if(data.siteItem){
              that.cityItem = data.siteItem
            }else{
              that.cityItem = data.cityItem
            }
          })
        }
      },
      init() {
      },
      editSearch(item){
        this.option.siteName = item.siteName;
        this.searchBlock = false;
        this.option.siteCode1 = item.siteCode;
      },
      searchEvent(it) {
        this.searchItem.forEach(e => {
          e.selected = false;
        });
        it.selected = true;
      },
    },
    mounted() {
      this.init();
    }
  };
</script>
